import React from 'react';

export default function MobileBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-dark-2 border-t border-dark-4 p-3 flex gap-3 pb-safe">
      <a href="tel:4433592010" className="flex-1 text-center py-3 px-4 rounded bg-gold text-dark font-condensed font-extrabold text-base uppercase tracking-wide no-underline flex items-center justify-center gap-2">
        📞 Call Now
      </a>
      <a href="sms:4433592010" className="flex-1 text-center py-3 px-4 rounded bg-dark-4 text-text font-condensed font-extrabold text-base uppercase tracking-wide no-underline flex items-center justify-center gap-2">
        💬 Text Us
      </a>
    </div>
  );
}